import React from 'react';
import './LegalPages.css';

const TermsOfServicePage = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1 className="legal-title">Terms of Service</h1>
        
        <div className="legal-meta">
          <p><strong>Effective Date:</strong> June 1, 2025</p>
          <p><strong>Owner:</strong> Site Owner (individual)</p>
        </div>

        <div className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using [YourWebsite.com] (the "Site"), you agree to be bound by these Terms of Service ("Terms") and the accompanying Privacy Policy. If you do not agree with any part of these Terms, do not use the Site.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. Ownership & Intellectual Property</h2>
          <ul>
            <li>All camouflage patterns generated by or through this platform, whether derived from user-submitted content or generated independently, are the <strong>exclusive intellectual property</strong> of the site's owner.</li>
            <li>By uploading any image, environment description, or related content, you:
              <ul>
                <li><strong>Assign all rights, titles, and interests</strong> in the submission to the site's owner.</li>
                <li><strong>Grant full, perpetual, royalty-free commercial use rights</strong> without further notice or compensation.</li>
                <li><strong>Waive any claim</strong> to ownership, attribution, or approval.</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Upload or submit any content you do not have the legal rights to use.</li>
            <li>Use the Site for any unlawful, abusive, or exploitative purposes.</li>
            <li>Attempt to reverse-engineer, scrape, or exploit the platform.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. No Warranty</h2>
          <p>
            The Site and all services provided are offered <strong>"as is"</strong> and <strong>"as available"</strong> without warranties of any kind, either express or implied.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Limitation of Liability</h2>
          <p>To the fullest extent permitted by law:</p>
          <blockquote>
            The site's owner shall not be liable for any direct, indirect, incidental, consequential, or punitive damages, including but not limited to data loss, unauthorized access, system downtime, or disruption of services, arising out of or related to your use of the Site.
          </blockquote>
        </div>

        <div className="legal-section">
          <h2>6. Assumption of Risk</h2>
          <p>
            You use the Site at your own risk. You are solely responsible for safeguarding any content you upload or generate, and you acknowledge that the Site may be vulnerable to unauthorized access, data loss, or third-party attacks.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the <strong>State of Arizona</strong>, without regard to its conflict of law principles.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Modifications</h2>
          <p>
            These Terms may be updated at any time without prior notice. Continued use of the Site after any such changes constitutes acceptance of the updated Terms.
          </p>
        </div>

        <div className="legal-footer">
          <p>Last updated: June 1, 2025</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage; 